import React, { ReactNode } from "react";
import { Route, RouteProps, Routes } from "react-router-dom";
import Home from "pages";
import Health from "pages/health";
import MultipleRealms from "pages/multiple-realms";
import NotFound from "pages/not-found";
import Attendance from "pages/private/attendance";
import Document from "pages/private/document";
import Lobby from "pages/private/lobby";
import Location from "pages/private/location";
import LocationForm from "pages/private/location/form";
import Process from "pages/private/process";
import Dashboard from "pages/private/readers-tags/dashboard";
import Readers from "pages/private/readers-tags/readers";
import Tags from "pages/private/readers-tags/tags";
import Report from "pages/private/report/inbound-outbound";
import Movements from "pages/private/report/movements";
import Users from "pages/private/user";
import UsersForm from "pages/private/user/form";
import UnauthorizedPage from "pages/unauthorized";
import VehicleDashboard from "screens/private/vehicle-dashboard";
import SignIn from "screens/public/signin";

type AppRoute = RouteProps & {
  path: string;
  element: ReactNode;
};

const routes: AppRoute[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/health",
    element: <Health />,
  },
  {
    path: "/multiple-realms",
    element: <MultipleRealms />,
  },
  {
    path: "/private/lobby",
    element: <Lobby />,
  },
  {
    path: "/private/attendance",
    element: <Attendance />,
  },
  {
    path: "/private/location",
    element: <Location />,
  },
  {
    path: "/private/location/form/:id",
    element: <LocationForm />,
  },
  {
    path: "/private/location/form",
    element: <LocationForm />,
  },
  {
    path: "/private/report/inbound-outbound",
    element: <Report />,
  },
  {
    path: "/private/report/movements",
    element: <Movements />,
  },
  {
    path: "/private/readers-tags/readers",
    element: <Readers />,
  },
  {
    path: "/private/readers-tags/tags",
    element: <Tags />,
  },
  {
    path: "/private/readers-tags/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/private/user",
    element: <Users />,
  },
  {
    path: "/private/user/form",
    element: <UsersForm />,
  },
  {
    path: "/private/document",
    element: <Document />,
  },
  {
    path: "/private/process",
    element: <Process />,
  },
  {
    path: "/unauthorized",
    element: <UnauthorizedPage />,
  },
  {
    path: "/private/vehicle-dashboard",
    element: <VehicleDashboard />,
  },
  {
    path: "/signin",
    element: <SignIn />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

const AppRoutes = () => {
  return (
    <Routes>
      {routes.map((route, i) => (
        <Route key={i} {...route} />
      ))}
    </Routes>
  );
};

export default AppRoutes;
